'use client';
import { typeStyleMap } from './fixtures';
import { getTypeStyle, getTypeStyleSkeleton } from './getTypeStyle';
export * from './BaseTypeStyle';
export * from './fixtures';
export * from './getTypeStyle';
export * from './types';
export const TypeStyleHeadlineExtraLarge = getTypeStyle('headlineExtraLarge');
export const TypeStyleHeadlineLarge = getTypeStyle('headlineLarge');
export const TypeStyleHeadlineMedium = getTypeStyle('headlineMedium');
export const TypeStyleHeadlineSmall = getTypeStyle('headlineSmall');
export const TypeStyleHeadlineExtraSmall = getTypeStyle('headlineExtraSmall');
export const TypeStyleHeadlineExtraExtraSmall = getTypeStyle('headlineExtraExtraSmall');
export const TypeStyleHeadlineMicro = getTypeStyle('headlineMicro');
export const TypeStyleEyebrow = getTypeStyle('eyebrow');
export const TypeStyleBodyDefault = getTypeStyle('bodyDefault');
export const TypeStyleBodyLarge = getTypeStyle('bodyLarge');
export const TypeStyleBodyMedium = getTypeStyle('bodyMedium');
export const TypeStyleBodySmall = getTypeStyle('bodySmall');
export const TypeStyleBodyMicro = getTypeStyle('bodyMicro');
export const TypeStyleBodyNano = getTypeStyle('bodyNano');
export const TypeStyleBodyTiny = getTypeStyle('bodyTiny');
export const TypeStyle = {
    css: typeStyleMap,
    HeadlineExtraLarge: TypeStyleHeadlineExtraLarge,
    HeadlineLarge: TypeStyleHeadlineLarge,
    HeadlineMedium: TypeStyleHeadlineMedium,
    HeadlineSmall: TypeStyleHeadlineSmall,
    HeadlineExtraSmall: TypeStyleHeadlineExtraSmall,
    HeadlineExtraExtraSmall: TypeStyleHeadlineExtraExtraSmall,
    HeadlineMicro: TypeStyleHeadlineMicro,
    Eyebrow: TypeStyleEyebrow,
    BodyDefault: TypeStyleBodyDefault,
    BodyLarge: TypeStyleBodyLarge,
    BodyMedium: TypeStyleBodyMedium,
    BodySmall: TypeStyleBodySmall,
    BodyMicro: TypeStyleBodyMicro,
    BodyNano: TypeStyleBodyNano,
    BodyTiny: TypeStyleBodyTiny,
};
export const TypeStyleHeadlineExtraLargeSkeleton = getTypeStyleSkeleton('headlineExtraLarge');
export const TypeStyleHeadlineLargeSkeleton = getTypeStyleSkeleton('headlineLarge');
export const TypeStyleHeadlineMediumSkeleton = getTypeStyleSkeleton('headlineMedium');
export const TypeStyleHeadlineSmallSkeleton = getTypeStyleSkeleton('headlineSmall');
export const TypeStyleHeadlineExtraSmallSkeleton = getTypeStyleSkeleton('headlineExtraSmall');
export const TypeStyleHeadlineExtraExtraSmallSkeleton = getTypeStyleSkeleton('headlineExtraExtraSmall');
export const TypeStyleHeadlineMicroSkeleton = getTypeStyleSkeleton('headlineMicro');
export const TypeStyleEyebrowSkeleton = getTypeStyleSkeleton('eyebrow');
export const TypeStyleBodyDefaultSkeleton = getTypeStyleSkeleton('bodyDefault');
export const TypeStyleBodyLargeSkeleton = getTypeStyleSkeleton('bodyLarge');
export const TypeStyleBodyMediumSkeleton = getTypeStyleSkeleton('bodyMedium');
export const TypeStyleBodySmallSkeleton = getTypeStyleSkeleton('bodySmall');
export const TypeStyleBodyMicroSkeleton = getTypeStyleSkeleton('bodyMicro');
export const TypeStyleBodyNanoSkeleton = getTypeStyleSkeleton('bodyNano');
export const TypeStyleBodyTinySkeleton = getTypeStyleSkeleton('bodyTiny');
//# sourceMappingURL=index.js.map